import { MenuComponent } from './menu/menu.component';
import { MenuAdminComponent } from './menu-admin.component';

const routes = [
    {
        path: 'menu',
        component: MenuAdminComponent,
        outlet: 'admin',
        children: [
            {
                path: '',
                component: MenuComponent,
            },
        ],
    },
];

export { routes as menuAdminRoutes };
